<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.Asset.auditHistory">Asset Audit History</mat-card-title>
  <div class="crud-item-section">
    <span>
      <mat-form-field matTooltip="Id">
        <mat-label i18n="@@type.Asset.assetId">Id</mat-label>
        <input matInput assetId="assetId" [ngModel]="item?.assetId" #assetId              
            type="number" placeholder="Id" disabled>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Created By">
        <mat-label i18n="@@type.Asset.createdBy">Created By</mat-label>
        <input matInput id="createdBy" [ngModel]="item?.createdBy"  #createdBy              
            maxlength="255" placeholder="Created By" disabled>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Created Date">
        <mat-label i18n="@@type.Asset.createdDate">Created Date</mat-label>
        <input matInput id="createdDate" [ngModel]="item?.createdDate"  #createdDate              
            [matDatepicker]="createdDateDatePicker" placeholder="Created Date" disabled>
        <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>
  
    <span>
      <mat-form-field matTooltip="Updated By">
        <mat-label i18n="@@type.Asset.lastUpdatedBy">Last Updated By</mat-label>
        <input matInput id="updatedBy" [ngModel]="item?.updatedBy" #updatedBy              
            maxlength="255" placeholder="Updated By" disabled>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Updated Date">
        <mat-label i18n="@@type.Asset.lastUpdatedDate">Last Updated Date</mat-label>
        <input matInput id="updatedDate" [ngModel]="item?.updatedDate" #updatedDate              
            [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date" disabled>
        <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>

  </div>
  <mat-card-content>
    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="auditDataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <app-audit-revision-info-columns [cellClassFn]="cellClass" [columns]="columns"></app-audit-revision-info-columns>
          <app-asset-search-result-columns [cellClassFn]="cellClass" [columns]="columns"></app-asset-search-result-columns>
          <app-mechanical-aspect-search-result-columns [cellClassFn]="cellClass" [previousRevisionGetter]="assetPreviousRevisionGetter" [columns]="columns"></app-mechanical-aspect-search-result-columns>
          <app-maintenance-aspect-search-result-columns [cellClassFn]="cellClass" [previousRevisionGetter]="assetPreviousRevisionGetter" [columns]="columns"></app-maintenance-aspect-search-result-columns>
          <app-electrical-aspect-search-result-columns [cellClassFn]="cellClass" [previousRevisionGetter]="assetPreviousRevisionGetter" [columns]="columns"></app-electrical-aspect-search-result-columns>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
    </div>
    <div>
    <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    <app-column-picker-dialog-launcher [columns]="columns">
    </app-column-picker-dialog-launcher>
    </div>
  </mat-card-content>
</mat-card>